import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as myGlobals from "./globalPath";

@Injectable()
export class FileService {

  constructor(private http: HttpClient) { }

  postFile(obj): Observable<any> {
    const headers = new HttpHeaders().append('Content-Type', 'multipart/form-data');
    return this.http.post(
      myGlobals.BaseUrlIdentity + myGlobals.uploadFileUrl,
      obj, { headers: headers, reportProgress: true, observe: 'events' }
    );
  }
  RemoveFile(fileId): Observable<any> {

    return this.http.delete(
      myGlobals.BaseUrlIdentity + myGlobals.deleteFileActualDEleting + fileId

    );
  }

  getImage(imageUrl: string) {
    return this.http
      .get(imageUrl, {
        responseType: 'blob',
      })
      .pipe(map((res: any) => {
        return {
          filename: 'image',
          data: res
        };
      }))
  }

}
